import { useParams, useNavigate } from 'react-router-dom';
import { verifyEmailLink, verifyEmailForgotPassword } from '../api/apiService';
import React, { useState, useEffect } from 'react';

function VerifyEmail() {
  const navigate = useNavigate();
  const params = useParams();
  const [statusObj, setStatueObj] = useState({});
  const [isVerifying, setVerifying] = useState(true);
  const [redirectTime, setRedirectTime] = useState(5);

  const _init = () => {
    const deviceId = localStorage.getItem("x-device-service-id");
    if (params.type === "create-account") {
      verifyEmailLink({ token: params.token, deviceId })
        .then(r => { setStatueObj(r?.data); setVerifying(false); })
        .catch(e => { setStatueObj(e?.response?.data); setVerifying(false); });
    } else if (params.type === "forgot-password") {
      verifyEmailForgotPassword({ token: params.token, deviceId })
        .then(r => {
          setStatueObj(r?.data); setVerifying(false);
          let time = redirectTime;
          const t = setInterval(() => {
            time--; setRedirectTime(time);
            if (time <= 0) { clearInterval(t); navigate(`/reset-password/${r?.data?.data?.accessToken}`); }
          }, 1000);
        })
        .catch(e => { setStatueObj(e?.response?.data); setVerifying(false); });
    }
  };

  useEffect(() => { _init(); }, []);

  const CyberIcon = ({ color, bg, borderColor, shadow, children }) => (
    <div className={`mx-auto w-16 h-16 flex items-center justify-center mb-6`}
      style={{ background: bg, border: `1px solid ${borderColor}`, boxShadow: shadow, clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)' }}>
      <svg className="w-8 h-8" style={{ color, filter: `drop-shadow(0 0 5px ${color})` }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
        {children}
      </svg>
    </div>
  );

  const ActionButton = ({ href, label }) => (
    <a href={href} className="cyber-btn inline-flex justify-center py-4 px-8 mt-4 w-full text-center">
      {label}
    </a>
  );

  const verificationStatus = () => {
    if (isVerifying) return (
      <div className="text-center">
        <div className="mx-auto w-16 h-16 flex items-center justify-center mb-6 relative border border-cyan-500 bg-cyan-900/30" style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%)' }}>
          <div className="w-8 h-8 border-4 border-cyan-900 border-t-cyan-400 rounded-full animate-spin"/>
        </div>
        <h2 className="text-xl font-black text-cyan-400 tracking-widest uppercase drop-shadow-[0_0_8px_rgba(0,255,255,0.3)] mb-3">VERIFYING_UPLINK...</h2>
        <p className="cyber-label text-[10px]">AWAITING MAINFRAME CONFIRMATION.</p>
      </div>
    );

    if (statusObj?.data?.type === "create_account_link_already_verified") return (
      <div className="text-center">
        <CyberIcon color="#0ff" bg="rgba(0,255,255,0.1)" borderColor="rgba(0,255,255,0.5)" shadow="0 0 15px rgba(0,255,255,0.2)">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </CyberIcon>
        <h2 className="text-xl font-black text-white tracking-widest uppercase mb-3">ALREADY_VERIFIED</h2>
        <p className="cyber-label text-[10px] mb-6">{statusObj?.data?.msg || "NODE ALREADY ACTIVE."}</p>
        <ActionButton href="/profile" label="ACCESS_PROFILE"/>
      </div>
    );

    if (statusObj?.data?.type === "invalid_link_forgot_password") return (
      <div className="text-center">
        <CyberIcon color="#f0f" bg="rgba(255,0,255,0.1)" borderColor="rgba(255,0,255,0.5)" shadow="0 0 15px rgba(255,0,255,0.2)">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
        </CyberIcon>
        <h2 className="text-xl font-black text-fuchsia-500 tracking-widest uppercase mb-3 drop-shadow-[0_0_8px_rgba(255,0,255,0.4)]">VERIFICATION_FAILED</h2>
        <p className="cyber-label text-[10px] mb-6">{statusObj?.data?.msg || "UPLINK EXPIRED OR INVALID."}</p>
        <ActionButton href="/forgot-password" label="RETRY_CONNECTION"/>
      </div>
    );

    if (statusObj?.data?.type === "email_verification_success") return (
      <div className="text-center">
        <CyberIcon color="#0f0" bg="rgba(0,255,0,0.1)" borderColor="rgba(0,255,0,0.5)" shadow="0 0 15px rgba(0,255,0,0.2)">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"/>
        </CyberIcon>
        <h2 className="text-xl font-black text-green-400 tracking-widest uppercase mb-3 drop-shadow-[0_0_8px_rgba(0,255,0,0.4)]">VERIFICATION_SUCCESS</h2>
        <p className="cyber-label text-[10px] mb-6">NODE ACTIVATED. MAINFRAME ACCESS GRANTED.</p>
        <ActionButton href="/profile" label="ACCESS_PROFILE"/>
      </div>
    );

    if (statusObj?.data?.type === "email_verification_success_forgot_password") return (
      <div className="text-center">
        <CyberIcon color="#0f0" bg="rgba(0,255,0,0.1)" borderColor="rgba(0,255,0,0.5)" shadow="0 0 15px rgba(0,255,0,0.2)">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"/>
        </CyberIcon>
        <h2 className="text-xl font-black text-green-400 tracking-widest uppercase mb-3 drop-shadow-[0_0_8px_rgba(0,255,0,0.4)]">VERIFICATION_SUCCESS</h2>
        <p className="cyber-label text-[10px] mb-6">INITIATING KEY RESET PROTOCOL...</p>
        
        <div className="inline-flex items-center gap-2 px-4 py-2 text-[10px] font-bold text-green-400 border border-green-500/30 bg-green-900/20 uppercase tracking-widest" style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 6px), calc(100% - 6px) 100%, 0 100%)' }}>
          <span className="w-1.5 h-1.5 bg-green-400 animate-pulse"/>
          REDIRECTING IN {redirectTime}s...
        </div>
      </div>
    );

    return (
      <div className="text-center">
        <CyberIcon color="#f00" bg="rgba(255,0,0,0.1)" borderColor="rgba(255,0,0,0.5)" shadow="0 0 15px rgba(255,0,0,0.2)">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
        </CyberIcon>
        <h2 className="text-xl font-black text-red-500 tracking-widest uppercase mb-3 drop-shadow-[0_0_8px_rgba(255,0,0,0.4)]">SYSTEM_ERROR</h2>
        <p className="cyber-label text-[10px] mb-6 text-red-400/80">{statusObj?.data?.msg || "UNKNOWN EXCEPTION OCCURRED."}</p>
        <ActionButton href="/login" label="RETURN_TO_LOGIN"/>
      </div>
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 relative overflow-hidden">
      {/* Background Image Layer */}
      <div className="absolute inset-0 cyber-auth-bg" />
      {/* Dynamic Overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-cyan-900/20 via-[#030305]/80 to-[#030305]/90" />
      
      <div className="relative z-10 w-full max-w-md">
        <div className="cyber-card p-8 md:p-10">
          {verificationStatus()}
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
